import { categorieOf } from "../lib/categorie";

export const CatBadge = ({ j, testid }) => {
  const c = categorieOf(j);
  if (!c) return null;
  return <span data-testid={testid} title={j.categorie ? "Catégorie choisie à la main" : "Catégorie calculée avec la date de naissance"} className="ml-1.5 inline-block rounded-md border border-lime/60 bg-lime/10 px-1.5 py-px align-middle font-mono text-[11px] font-semibold uppercase text-lime">{c}</span>;
};
